import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddAreaRequest } from '../models/request/area/AddAreaRequest';

export class AreaService {
    static async getAreaList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getAreaList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Area/getAreaList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addArea(inputObj: AddAreaRequest) {
        try {
            const formData = new FormData();

            if (!Helpers.isEmpty(inputObj.areaId))
                formData.append("AreaId", inputObj.areaId + '');

            formData.append("AreaName", inputObj.areaName);
            formData.append("Color", inputObj.color);

            if (inputObj.locations && inputObj.locations.length > 0)
                formData.append("Locations", JSON.stringify(inputObj.locations));

            if (inputObj.companyId)
                formData.append("CompanyId", inputObj.companyId)

            if (inputObj.file)
                formData.append("AreaKMLFile", inputObj.file);


            formData.append("BorderColor", inputObj.borderColor);
            formData.append("BorderWidth", inputObj.borderWidth.toString())
            formData.append("IsTransparent", inputObj.isTransparent ? "1" : "0")
            formData.append("AreaTypeId", inputObj.areaTypeId + '');

            console.log('SERVICE CALL - AddArea', JSON.stringify(formData));

            const resp = await axios.post(Helpers.getEndpoint() + '/Area/AddArea', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteArea(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteArea', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Area/deleteArea', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAreaById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getAreaById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Area/getAreaById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}